export const menuItems = [
  {
    id: 1,
    label: "menuitems.menu.text",
    isTitle: true,
  },
  {
    id: 22,
    label: "Users",
    permission: "Users",
    icon: "ri-menu-4-line",
    subItems: [
      {
        id: 1,
        label: "Users",
        link: "/users",
        permission: "Users",
      },
    ],
  },
  {
    id: 2,
    label: "Catalogue",
    permission: "Catalogue",
    icon: "ri-menu-4-line",
    subItems: [
      {
        id: 21,
        label: "Categories",
        link: "/categories",
        permission: "Categories",
      },
      {
        id: 22,
        label: "Modifier Groups",
        link: "/modifier_groups",
        permission: "Modifier_Groups",
      },
      {
        id: 23,
        label: "Modifiers",
        link: "/modifiers",
        permission: "Modifiers",
      },
      {
        id: 24,
        label: "Charges",
        link: "/charges",
        permission: "Charges",
      },
      {
        id: 25,
        label: "Items",
        link: "/items",
        permission: "Items",
      },
      {
        id: 26,
        label: "Menu",
        link: "/menu",
        permission: "Menu",
      },
    ],
  },
  {
    id: 12,
    label: "Support",
    permission: "Tickets",
    icon: "ri-menu-4-line",
    subItems: [
      {
        id: 121,
        label: "Category Level Assignee",
        link: "/category_level_assignee",
        permission: "TicketCategoryAssignee",
      },
      {
        id: 122,
        label: "Tickets",
        link: "/tickets_dashboard",
        permission: "TicketDashboard",
      },
      // {
      //   id: 31,
      //   label: "Tickets",
      //   link: "/tickets",
      //   permission: "TicketsList",
      // },
    ],
  },
  {
    id: 3,
    label: "Locations",
    permission: "Locations",
    icon: "ri-menu-4-line",
    subItems: [
      {
        id: 31,
        label: "Brands",
        link: "/brands",
        permission: "Brands",
      },
      {
        id: 32,
        label: "Restaurant Partners",
        link: "/restaurants",
        permission: "RestaurantPartner",
      },
      {
        id: 33,
        label: "stores (Res Id)",
        link: "/stores",
        permission: "Stores",
      },
      {
        id: 34,
        label: "RP PnL",
        link: "/rp_pnl",
        permission: "Rp_pnl",
      },
    ],
  },
  {
    id: 4,
    label: "Order Management",
    permission: "OrderManagement",
    icon: "ri-menu-4-line",
    subItems: [
      {
        id: 41,
        label: "Orders",
        link: "/orders",
        permission: "OrderManagement",
      },
    ],
  },
  {
    id: 5,
    label: "Inventory",
    permission: "Inventory",
    icon: "ri-menu-4-line",
    subItems: [
      {
        id: 51,
        label: "Raw Materials",
        link: "/raw_materials",
        permission: "RawMaterials",
      },
      {
        id: 52,
        label: "Raw Material Invards",
        link: "/raw_material_orders",
        permission: "RawMaterialOrders",
      },      
      {
        id: 53,
        label: "Gravy",
        link: "/gravies",
        permission: "Gravies",
      },
      {
        id: 54,
        label: "Packaging",
        link: "/packagings",
        permission: "Packagings",
      },
      {
        id: 722,
        label: "Packaging Invards",
        link: "/packaging_production_batches",
        permission: "ProductionPackaging",
      },
      {
        id: 55,
        label: "Orders",
        link: "/gravy_orders",
        permission: "GravyOrderManagement",
      },
      {
        id: 56,
        label: "Gravy / Packaging Returns",
        link: "/gravy_orders_returns",
        permission: "GravyOrderReturnManagement",
      },
      {
        id: 20,
        label: "Vendors",
        link: "/vendors",
        permission: "Vendors",
      },
    ],
  },
  {
    id: 6,
    label: "Recipe Management",
    permission: "Recipe",
    icon: "ri-menu-4-line",
    subItems: [
      {
        id: 61,
        label: "RND Recipes",
        link: "/raw_material_to_gravy_recipe",
        permission: "Recipe",
      },
      {
        id: 62,
        label: "R-G Recipe Card",
        link: "/raw_material_to_gravy_recipe_card",
        permission: "RecipeCard",
      },
    ],
  },
  {
    id: 7,
    label: "Warehouse Mngmnt",
    permission: "Warehouse",
    icon: "ri-menu-4-line",
    subItems: [
      {
        id: 71,
        label: "Warehouses",
        link: "/warehouses",
        permission: "Warehouse",
      },
      {
        id: 72,
        label: "Production Batches",
        permission: "Production",
        subItems: [
          {
            id: 721,
            label: "Gravy Batches",
            link: "/gravy_production_batches",
            permission: "ProductionGravy",
          }          
        ],
      },
      {
        id: 73,
        label: "Transfer Batches",
        permission: "Transfer",
        subItems: [
          {
            id: 731,
            label: "Gravy Batches",
            link: "/gravy_transfer_batches",
            permission: "GravyTransfer",
          },
          {
            id: 732,
            label: "Packaging Batches",
            link: "/packaging_transfer_batches",
            permission: "PackagingTransfer",
          },
        ],
      },
      {
        id: 74,
        label: "Stock Details",
        link: "/stock_details",
        permission: "Warehouse_Stock_Details",
      },
      {
        id: 182,
        label: "Warehouse Insepection Import",
        link: "/warehouse_inspection_import",
        permission: "Warehouse_Inspection_Import",
      },
    ],
  },
  {
    id: 8,
    label: "Data Imports",
    permission: "Imports",
    icon: "ri-menu-4-line",
    subItems: [
      {
        id: 81,
        label: "Business Report",
        link: "/business_report",
        permission: "Business_Report",
      },
      {
        id: 82,
        label: "Stock Out Report",
        link: "/stock_out_report_import",
        permission: "Stock_Out_Import",
      },
      {
        id: 83,
        label: "Payout Policy",
        link: "/payout_policy",
        permission: "Payout_Import",
      },
      {
        id: 84,
        label: "Order Ratings Import",
        link: "/order_ratings_import",
        permission: "Order_Ratings_Import",
      },
      {
        id: 85,
        label: "Funnel Data",
        link: "/funnel_import",
        permission: "Funnel_import",
      },
      {
        id: 86,
        label: "Rhi Data",
        link: "/rhi_import",
        permission: "Rhi_Import",
      },
      {
        id: 87,
        label: "Complaints Data",
        link: "/complaints_import",
        permission: "Complaints_Import",
      },
    ],
  },
  {
    id: 9,
    label: "Outlet Inspection",
    permission: "Inspection",
    icon: "ri-menu-4-line",
    subItems: [
      {
        id: 91,
        label: "Stock Inspection",
        link: "/stock_inspection",
        permission: "stock_inspection",
      },
      {
        id: 92,
        label: "Inspection Data",
        link: "/stock_inspection_data",
        permission: "stock_inspection_list",
      },
    ],
  },
  {
    id: 10,
    label: "Incentives",
    permission: "Incentives",
    icon: "ri-menu-4-line",
    subItems: [
      {
        id: 101,
        label: "Staff Incentives",
        link: "/staff_incentives",
        permission: "StaffIncentives",
      },
    ],
  },
  {
    id: 11,
    label: "Analytics",
    permission: "Analytics",
    icon: "ri-menu-4-line",
    subItems: [
      {
        id: 111,
        label: "Gravy Projection",
        link: "/gravy_projection",
        permission: "GravyProjection",
      },
      {
        id: 112,
        label: "Packaging Projection",
        link: "/packaging_projection",
        permission: "PackagingProjection",
      },
      {
        id: 113,
        label: "Projection Data",
        link: "/projection_data",
        permission: "ProjectionData",
      },
      // {
      //   id: 113,
      //   label: "Gravy Consumption Analytics",
      //   link: "/gravy_consumption",
      //   permission: "Gravy_Consumption_Analytics",
      // },
      // {
      //   id: 114,
      //   label: "Packaging Consumption Analytics",
      //   link: "/packaging_consumption",
      //   permission: "Packaging_Consumption_Analytics",
      // },
      {
        id: 115,
        label: "Warehouse Stock Management",
        link: "/warehouse_stock_analytics",
        permission: "WarehouseStockManagement",
      },
      {
        id: 116,
        label: "Warehouse Projection",
        link: "/warehouse_projection",
        permission: "WarehouseProjection",
      },
      {
        id: 117,
        label: "Catalogue Analytics",
        link: "/catalogue_analytics",
        permission: "CatalogurAnalytics",
      },
      {
        id: 118,
        label: "Sales Analytics",
        link: "/sales_analytics",
        permission: "SalesAnalytics",
      },
      {
        id: 119,
        label: "Outlet Analytics",
        link: "/outlet_performance",
        permission: "OutletAnalytics",
      },
      {
        id: 1110,
        label: "Outlet Map View",
        link: "/outlet_map_view",
        permission: "OutletMapView",
      },
      {
        id: 1111,
        label: "Funnel Analytics",
        link: "/funnel_analytics",
        permission: "FunnelAnalytics",
      },
      {
        id: 1112,
        label: "StockOut Analytics",
        link: "/stock_out_analytics",
        permission: "StockOut_Analytics",
      },
      {
        id: 1113,
        label: "Complaints Analytics",
        link: "/complaints_analytics",
        permission: "Complaints_Analytics",
      },
      {
        id: 1114,
        label: "Rhi Analytics",
        link: "/rhi_analytics",
        permission: "Rhi_Analytics",
      },
      {
        id: 1115,
        label: "Restaurant Analytics",
        link: "/restaurant_analytics",
        permission: "RestaurantAnalytics",
      },
      {
        id: 1116,
        label: "Restaurant Payout Analytics",
        link: "/restaurant_payout_analytics",
        permission: "Restaurant_Payout_Analytics",
      },
      {
        id: 1117,
        label: "Item Rating Dashboard",
        link: "/item_ratings_analytics",
        permission: "ItemRatingDashboard",
      },
      {
        id: 1118,
        label: "New Launches Revenue Contribution Dashboard",
        link: "/new_launches_revenue_contribution",
        permission: "New_Launch_Revenue_Contribution_Dashboard",
      },
      {
        id: 1119,
        label: "Gravy Varience Dashboard",
        link: "/gravy_varience_analytics",
        permission: "Gravy_Varience_Dashboard",
      },
      {
        id: 1120,
        label: "Model Outlet Analytics Dashboard",
        link: "/model_outlet_analytics",
        permission: "Model_Outlet_Analytics",
      },
      {
        id: 1121,
        label: "Outlet Inventory Stock",
        link: "/outlet_inventory_stock",
        permission: "Outlet_Inventory_Stock",
      },
    ],
  },
];
